module.exports = __webpack_public_path__ + "static/soc2-0ca97f68b3b7b34cc9b8faf6dacae4f0.png";